module.exports = __webpack_public_path__ + "img/gmail.7883dab2.svg";